/**
 * @file Step Accordion
 */

import { gsap } from "gsap";

/**
 * Step Accordion component
 */
const vStepAccordion = () => {
	const stepAccordion = document.querySelector(".v-step-accordion");
	if (!stepAccordion) {
		return;
	}
	const triggers = stepAccordion.querySelectorAll(".v-step-accordion__header");
	let isAnimating = false;
	const tl = gsap.timeline({
		defaults: { ease: "sine.out", duration: 0.3 },
		onStart: () => {
			isAnimating = true;
		},
		onComplete: () => {
			isAnimating = false;
		},
	});

	[...triggers].forEach((trigger) => {
		trigger.addEventListener("click", (e) => {
			e.preventDefault();

			if (isAnimating) {
				return;
			}

			const item = trigger.closest(".v-step-accordion__item");
			const content = item.querySelector(".v-step-accordion__content");
			const isOpen = item.classList.contains("is-active");

			// Close other accordions
			[...triggers].forEach((otherTrigger) => {
				const otherItem = otherTrigger.closest(".v-step-accordion__item");
				if (otherItem !== item && otherItem.classList.contains("is-active")) {
					const otherContent = otherItem.querySelector(
						".v-step-accordion__content"
					);
					tl.to(otherContent, { opacity: 0 }).to(
						otherContent,
						{
							height: 0,
							onComplete: () => {
								otherItem.classList.remove("is-active");
								otherTrigger.setAttribute("aria-expanded", "false");
								otherContent.setAttribute("aria-hidden", "true");
								otherContent.removeAttribute("style");
							},
						},
						">"
					);
				}
			});

			if (isOpen) {
				tl.to(content, { opacity: 0 }).to(
					content,
					{
						height: 0,
						onComplete: () => {
							item.classList.remove("is-active");
							trigger.setAttribute("aria-expanded", "false");
							content.setAttribute("aria-hidden", "true");
							content.removeAttribute("style");
						},
					},
					">"
				);
			} else {
				content.style.display = "block";
				const contentHeight = content.scrollHeight;

				tl.to(content, {
					height: contentHeight,
				}).fromTo(
					content,
					{ opacity: 0 },
					{
						opacity: 1,
						onComplete: () => {
							trigger.setAttribute("aria-expanded", "true");
							content.setAttribute("aria-hidden", "false");
							item.classList.add("is-active");
							content.removeAttribute("style");
						},
					},
					">"
				);
			}
		});
	});
};

export default vStepAccordion;
